module.exports = __webpack_public_path__ + "img/appAsset-brand--RedCompra.f4409222.svg";